import {Locale} from '@hebcal/hdate';
import poData from './ashkenazi_litvish.po.js';
Locale.addLocale('ashkenazi_litvish', poData);
